import { useEffect, useState } from 'react';
import API, { UPLOADS_URL } from '../api/axios';

const usePage = (slug, fallback = {}) => {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    API.get(`/pages/public/${slug}`)
      .then((res) => {
        if (active && res.data?.data) setData(res.data.data);
      })
      .catch(() => {})
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [slug]);

  const bannerImage = data.banner_image ? `${UPLOADS_URL}/${data.banner_image}` : null;
  const featuredImage = data.featured_image ? `${UPLOADS_URL}/${data.featured_image}` : null;

  return { ...data, bannerImage, featuredImage, loading };
};

export default usePage;
